// extracted by mini-css-extract-plugin
module.exports = {"carousel":"join-us-section_carousel__DjLcn","carousel__item":"join-us-section_carousel__item__l69ZO","container":"join-us-section_container__AV0cf"};